import type { Application } from 'pixi.js';
import type { BaseScene } from '../scenes/BaseScene';

// ---- Engine types (keep) ----

export interface GameConfig {
  width: number;
  height: number;
  backgroundColor: number;
  antialias: boolean;
  resolution: number;
}

export interface SceneContext {
  app: Application;
  width: number;
  height: number;
}

export interface FPSMetrics {
  current: number;
  average: number;
  min: number;
  max: number;
}

export interface AssetManifest {
  images: AssetEntry[];
  audio: AssetEntry[];
  data: AssetEntry[];
}

export interface AssetEntry {
  id: string;
  path: string;
  priority?: number;
}

export interface LoadProgress {
  loaded: number;
  total: number;
  percentage: number;
  currentAsset: string;
}

export type SceneConstructor = new (context: SceneContext) => BaseScene;

// ---- Kiwis vs Coconuts game types ----

export type Difficulty = 'easy' | 'medium' | 'hard';

export enum PieceType {
  KIWI = 'KIWI',
  COCONUT = 'COCONUT',
}

export enum PlayerSide {
  KIWI = 'KIWI',
  COCONUT = 'COCONUT',
}

export interface GridPosition {
  row: number;
  col: number;
}

export interface PieceData {
  id: string;
  type: PieceType;
  side: PlayerSide;
  position: GridPosition;
}

export type BoardState = (PieceData | null)[][];

export interface TurnState {
  currentSide: PlayerSide;
  turnNumber: number;
}

export interface GameState {
  board: BoardState;
  turn: TurnState;
  winner: PlayerSide | null;
  isGameOver: boolean;
}

export interface MoveResult {
  fromPosition: GridPosition;
  toPosition: GridPosition;
  capturedPiece: PieceData | null;
  movedPiece: PieceData;
}
